module.exports = __webpack_public_path__ + "img/training-report-disable.62b6c75e.svg";